module.exports = __webpack_public_path__ + "img/logo-menu.b5adaf7d.png";